// extracted by mini-css-extract-plugin
module.exports = {"heading":"CmsSeoTextBlock_heading__8TZ22","textContainer":"CmsSeoTextBlock_textContainer__jvudQ"};